import modalTemplate from './new-door.template.html';

export class NewDoorService {

    constructor($log, $uibModal) {
        'ngInject';
        this.$log = $log;
        this.$uibModal = $uibModal;
    }

    open() {

        var modalInstance = this.$uibModal.open({
            templateUrl: modalTemplate,
            controllerAs: '$ctrl'
        });

        return modalInstance
            .result
            .then(function (result) {
                return result;
            });

    }

}



// WEBPACK FOOTER //
// ./src/js/components/new-door/new-door.service.js